'use client';
import { useEffect, useState } from 'react';
import { CircleCheck, OctagonAlert } from 'lucide-react'; // Adjust the import path
import { Alert, AlertTitle } from './alert';

const AlertMessage = ({
  type,
  message,
}: {
  type: 'error' | 'success';
  message?: string;
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide the alert after one minute (60000 milliseconds)
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 60000);

    // Clear the timeout when the component unmounts
    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <>
      {type === 'error' && (
        <Alert className="flex items-center gap-2 border-destructive/50 bg-destructive/10 dark:border-destructive/70 dark:bg-destructive/20">
          <div>
            <OctagonAlert className="h-4 w-4 !text-destructive" />
          </div>
          <AlertTitle className="mb-0 capitalize leading-[normal] text-gray-700">
            {message || 'An error occurred. Please try again later.'}
          </AlertTitle>
        </Alert>
      )}

      {type === 'success' && (
        <Alert className="mt-3 flex items-center gap-2 border-emerald-300 bg-emerald-500/10 dark:border-emerald-600/70 dark:bg-emerald-600/30">
          <div>
            <CircleCheck className="h-4 w-4 !text-emerald-500" />
          </div>
          <AlertTitle className="mb-0 leading-[normal] text-gray-700">
            {message || 'Your action has been completed successfully.'}
          </AlertTitle>
        </Alert>
      )}
    </>
  );
};

export default AlertMessage;
